import queryString from 'query-string';
import { withMinisiteOverview } from '@/entries/_shared/minisiteOverviewGssp';

export const getLocationsServerSideProps = withMinisiteOverview(async (ctx, { companyOverview, companySlug }) => {
  const { countryCode, ...params } = ctx.query as { countryCode: string };
  const query = queryString.stringify(params);

  return {
    props: {
      companyOverview,
      companySlug,
      queryParams: query ? `?${query}` : '',
    },
  };
});
